var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-download-notice"},[(_vm.organizationVideoDownloadable)?[_vm._v("\n    ※購入するとダウンロードできます（MP4形式・パソコンのみ）。\n  ")]:[_vm._v("\n    ※購入した動画は注文履歴からいつでも見ることができます。また動画のデータをダウンロードすることはできません。\n  ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }